import axios from 'axios';
import moment from 'moment';

export async function init({ dispatch }) {
	dispatch('getCampaigns');
}

export async function getCampaigns({ commit }) {
	const { data } = await axios.get('/_dv_rtising/campaign');
	commit('SET_CAMPAIGNS', data.data);
}

export async function getCampaign({ commit }, campaignId) {
	const { data } = await axios.get(`/_dv_rtising/campaign/${campaignId}`);
	commit('SET_CAMPAIGN', data.data);
	commit('SET_CAMPAIGN_STATS', data.stats);
}

export async function getCampaignStats({ commit }, { campaignId, filter }) {
	filter = filter ? ({
		from: moment(filter.from, 'DD.MM.YYYY').format('YYYY-MM-DD'),
		to: moment(filter.to, 'DD.MM.YYYY').format('YYYY-MM-DD'),
	}) : null;
	const { data } = await axios.get(`/_dv_rtising/campaign/${campaignId}/stats`, {
		params: {
			filter,
		},
	});
	commit('SET_CAMPAIGN_STATS', data.stats);
}

export async function addCampaign({ commit }, campaign) {
	campaign.status = -1;
	const { data } = await axios.post('/_dv_rtising/campaign', campaign);
	commit('ADD_CAMPAIGN', data.data);
}

export async function updateCampaign({ commit }, campaign) {
	await axios.put(`/_dv_rtising/campaign/${campaign.id}`, campaign);
	commit('UPDATE_CAMPAIGN', campaign);
}
